import {
  SAVE_PROGRESS_REQUEST,
  SAVE_PROGRESS_SUCCESS,
  SAVE_PROGRESS_FAILURE,
  LOAD_PROGRESS_REQUEST,
  LOAD_PROGRESS_SUCCESS,
  LOAD_PROGRESS_FAILURE
} from '../actions'

const defaultState = {
  coach: {
    offered: false,
    offerText: null
  }
}

export default function api (state = defaultState, action) {
  switch (action.type) {
    case SAVE_PROGRESS_REQUEST:
      return { ...state }

    case SAVE_PROGRESS_SUCCESS:
      return {
        ...state,
        saveProgress: {
          success: true
        }
      }

    case SAVE_PROGRESS_FAILURE:
      return {
        ...state,
        saveProgress: {
          success: false,
          error: action.payload.error
        }
      }

    case LOAD_PROGRESS_REQUEST:
      return { ...state }

    case LOAD_PROGRESS_SUCCESS:
      return {
        ...state,
        loadProgress: {
          success: true
        }
      }

    case LOAD_PROGRESS_FAILURE:
      return {
        ...state,
        loadProgress: {
          success: false,
          error: action.payload.error
        }
      }

    default:
      return state
  }
}
